var App = App || {};

App.ProductFinder = (() => {
    'use strict';
    let productFinder;
    let products;
    let filterButtons;
    let resetButton;
    let resultsMessage;
    let filters = [];

    const init = (id) => {
        productFinder = document.getElementById(id);
        products = productFinder.querySelector('.product-finder__products');
        filterButtons = productFinder.querySelectorAll('.filter');
        resetButton = productFinder.querySelector('.product-finder__reset');
        resultsMessage = productFinder.querySelector('.product-finder__results-message');

        filterButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                const target = event.currentTarget;
                const isActive = target.classList.contains('filter--active');
                const filter = target.dataset.filter;

                if (!isActive) {
                    addFilter(filter);
                    target.classList.add('filter--active');
                } else {
                    removeFilter(filter);
                    target.classList.remove('filter--active');
                }

                updateProducts();
            });

            button.addEventListener('keydown', (event) => {
                if (event.key === 'ArrowDown') {
                    const activeProducts = products.querySelectorAll('.product--active');

                    if (activeProducts.length > 0) {
                        activeProducts[0].focus();
                    }
                }
            });
        });

        resetButton.addEventListener('click', reset);
    };

    const addFilter = (filter) => {
        if (!filters.includes(filter)) {
            filters.push(filter);
        }
    };

    const removeFilter = (filter) => {
        const index = filters.indexOf(filter);
        if (index !== -1) {
            filters.splice(index, 1);
        }
    };

    const updateProducts = () => {
        products.querySelectorAll('.product').forEach(product => {
            const productClasses = Array.from(product.classList);

            const hasFilterClass = filters.every(productClass =>
                productClasses.includes(productClass)
            );

            if (filters.length > 0) {
                resetButton.classList.add('d-block');
            } else {
                reset();
            }

            if (hasFilterClass) {
                product.classList.add('product--active');
            } else {
                product.classList.remove('product--active');
            }
        });

        updateResultsMessage();
    };

    const updateResultsMessage = () => {
        const activeProducts = products.querySelectorAll('.product--active');
        const message = activeProducts.length > 0
            ? `<span class="visually-hidden">${activeProducts.length} product${activeProducts.length > 1 ? 's' : ''} found. Press the down arrow to skip to results.</span>`
            : 'No products found.';
        resultsMessage.innerHTML = message;
    };

    const reset = () => {
        filters = [];
        products.querySelectorAll('.product').forEach(product => {
            product.classList.add('product--active');
            resetButton.classList.remove('d-block');
        });
        filterButtons.forEach(button => {
            button.classList.remove('filter--active');
        });

        updateResultsMessage();
    };

    return { init };
})();